<template>
  <div>
    <svg
      id="pie"
      width="290px"
      height="290px"
      viewbox="0 0 290 290"
      v-html="svgData"
    />
  </div>
</template>

<script>
export default {
  name: 'GraphComponent',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    values: Array,
    // eslint-disable-next-line vue/require-default-prop
    centerText: Array,
  },
  computed: {
    svgData() {
      const total = this.values.reduce((p, c) => p + c.value, 0);
      const fragment = document.createDocumentFragment();
      const outerRadius = 120;
      const innerRadius = 90;
      let startAngle = 0;
      let donutSvg = null;
      // eslint-disable-next-line
      if (this.values && this.centerText) {
        this.values.forEach(slice => {
          const { value, color } = slice;
          const sectorAngle = this.scale(value, total);
          const d = this.arc(
            startAngle,
            startAngle + sectorAngle,
            outerRadius,
            innerRadius
          );
          startAngle += sectorAngle;

          const path = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'path'
          );
          path.setAttribute('d', d);
          path.setAttribute('fill', color);
          fragment.appendChild(path);
        });

        const centerTextGroup = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'g'
        );
        centerTextGroup.setAttribute('transform', 'translate(125,125)');

        // line 1
        const lineOne = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );
        lineOne.setAttribute('text-anchor', 'middle');
        lineOne.setAttribute('class', 'label');
        lineOne.setAttribute('fill', '#000');
        lineOne.setAttribute('dy', -30);
        // eslint-disable-next-line prefer-destructuring
        lineOne.innerHTML = this.centerText[0];

        // line 2
        const lineTwo = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );
        lineTwo.setAttribute('text-anchor', 'middle');
        lineOne.setAttribute('class', 'label');
        lineTwo.setAttribute('fill', '#3e3e3e');
        lineTwo.setAttribute('dy', -10);

        // eslint-disable-next-line prefer-destructuring
        lineTwo.innerHTML = this.centerText[1];

        // line 3
        const lineThree = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'text'
        );
        lineThree.setAttribute('text-anchor', 'middle');
        lineOne.setAttribute('class', 'value');
        lineTwo.setAttribute('class', 'value');
        lineThree.setAttribute('class', 'amount');
        lineThree.setAttribute('fill', '#000');
        lineThree.setAttribute('dy', 30);

        // eslint-disable-next-line prefer-destructuring
        let lineThreeNum = Number(this.centerText[2]);
        lineThreeNum = Number(lineThreeNum.toFixed());

        // eslint-disable-next-line prefer-template
        lineThree.innerHTML = '$' + lineThreeNum.toLocaleString();

        centerTextGroup.appendChild(lineThree);
        centerTextGroup.appendChild(lineOne);
        centerTextGroup.appendChild(lineTwo);

        fragment.appendChild(centerTextGroup);
      }

      const serializer = new XMLSerializer();
      donutSvg = serializer.serializeToString(fragment);

      return donutSvg;
    },
  },
  methods: {
    scale(value, total) {
      return (value * Math.PI * 2) / total;
    },

    arc(startAngle, endAngle, outerRadius, innerRadius) {
      const sinAlpha = Math.sin(startAngle);
      const cosAlpha = Math.cos(startAngle);
      const sinBeta = Math.sin(endAngle);
      const cosBeta = Math.cos(endAngle);
      const largeArc = endAngle - startAngle > Math.PI;

      const P = {
        x: outerRadius + outerRadius * sinAlpha,
        y: outerRadius - outerRadius * cosAlpha,
      };

      const Q = {
        x: outerRadius + outerRadius * sinBeta,
        y: outerRadius - outerRadius * cosBeta,
      };

      const R = {
        x: outerRadius + innerRadius * sinBeta,
        y: outerRadius - innerRadius * cosBeta,
      };

      const S = {
        x: outerRadius + innerRadius * sinAlpha,
        y: outerRadius - innerRadius * cosAlpha,
      };
      return `M${P.x},${P.y} A${outerRadius},${outerRadius} 0 ${
        largeArc ? '1,1' : '0,1'
      } ${Q.x},${Q.y} L${R.x},${R.y} A${innerRadius},${innerRadius} 0 ${
        largeArc ? '1,0' : '0,0'
      } ${S.x},${S.y} Z`;
    },
  },
};
</script>

<style lang="scss">
</style>
